import React, {useEffect, useMemo, useState} from "react";
import { useSearchParams } from "react-router-dom";
import SearchBox from "../../components/general/searchBox";
import DeleteOrganizationModal from "../../components/organization/deleteOrganizationModal";
import { useWindowSize } from "../../../hook/useWindowSize";
import { useMySearchParams } from "../../../hook/useMySearchParams";
import Pagination from "../../components/general/table/pagination";
import {useFindAccessInAccessList} from "../../../constants/constant/accessProcess";
import {useGetFilledPrescriptionDeliverList} from "../../../hook/request/ihioPrescriptionFilling";
import PrescriptionFillingTrackingCodeCard
    from "../../components/ihioPrescriptionFilling/prescriptionFillingTrackingCodeCard";
import PrescriptionFillingTable from "../../components/ihioPrescriptionFilling/dataList/prescriptionFillingTable";
import DatePickerField from "../../components/general/form/datePickerField";
import {useForm} from "react-hook-form";
import moment from "moment/moment";
import OrderedPrescriptionInfoModal
    from "../../components/ihioPrescriptionFilling/filledPrescriptionDeliverInfoModal/filledPrescriptionDeliverInfoModal";

const dataListTitles = [
    "نام و نام خانوادگی",
    "شماره ملی",
    "تاریخ ارائه",
    "شناسه رهگیری",
    "شناسه توالی",
    "عملیات",
]

type TFilterValues = {
    pageNumber?: string;
    perPage?: string;
    search?: string;
    fromDate?: string;
    toDate?: string;
}

const IhioPrescriptionFillingList = () => {

    const [width] = useWindowSize();
    const {findAccessInAccessList} = useFindAccessInAccessList();
    const [searchParams] = useSearchParams();
    const { getQueryParams, updateSearchParams } = useMySearchParams();
    const [prescriptionFillingsData, setPrescriptionFillingsData] = useState([]);
    const [filterValues, setFilterValues] = useState<TFilterValues>({
        pageNumber: "0",
        perPage: "10",
        search: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<TFilterValues>({
        defaultValues: useMemo(() => filterValues, [filterValues]),
    });

    // services
    const getFilledPrescriptionDeliverListRequest = useGetFilledPrescriptionDeliverList(getQueryParams(filterValues));

    useEffect(() => {
        let _filterValues = {};
        _filterValues = {
            ...filterValues,
            pageNumber: searchParams.get("pageNumber") || "0",
            perPage: searchParams.get("perPage") || "10",
            search: searchParams.get("search") || "",
            fromDate: searchParams.get("fromDate") || "",
            toDate: searchParams.get("toDate") || "",
        }
        setFilterValues(_filterValues)
    }, [searchParams]);

    useEffect(() => {
        getFilledPrescriptionDeliverListRequest?.data?.data?.result &&
        setPrescriptionFillingsData(getFilledPrescriptionDeliverListRequest?.data?.data.result)
    }, [getFilledPrescriptionDeliverListRequest.data])

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        let formatted = {}
        if(name === 'fromDate' || name === 'toDate') {
            const momentDate = moment.tz(value, 'Asia/Tehran');
            formatted = momentDate.format('YYYY-MM-DDTHH:mm:ss');
        }

        updateSearchParams({
            pageNumber: "0",
            perPage: filterValues?.perPage,
            [name]: (name === 'fromDate' || name === 'toDate') ? formatted : value,
        })
    }

    const doChangePage = (param: any) => {
        updateSearchParams({
            pageNumber: param?.index,
            perPage: filterValues?.perPage,
        })
    }

    return (
        <>
            <PrescriptionFillingTrackingCodeCard/>
            <div className="card-box">
                <section className="filter-box d-flex flex-column flex-md-row mb-4">
                    <div className="d-flex align-items-center gap-3 form-group ms-md-auto">
                        <SearchBox
                            name="search"
                            value={filterValues?.search}
                            onChange={handleFilterChange}
                            placeholder="جستجوی ارائه"
                        />
                        <DatePickerField
                            name="fromDate"
                            placeholder="تاریخ شروع"
                            control={control}
                            error={errors}
                            onChange={handleFilterChange}
                        />
                        <DatePickerField
                            name="toDate"
                            placeholder="تاریخ پایان"
                            control={control}
                            error={errors}
                            onChange={handleFilterChange}
                        />
                    </div>
                </section>

                <section className="table-cont table-responsive">
                    <PrescriptionFillingTable
                        dataList={prescriptionFillingsData}
                        dataListTitles={dataListTitles}
                        isRequesting={getFilledPrescriptionDeliverListRequest.isPending}
                    />
                    <Pagination
                        paginationData={{...filterValues, ...prescriptionFillingsData}}
                        doChangePage={doChangePage}
                    />
                </section>
            </div>

            <OrderedPrescriptionInfoModal />
        </>
    );
};

export default IhioPrescriptionFillingList;